"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContentProvider = createContentProvider;
function createContentProvider(api) {
    function parseContentObject(item) {
        return {
            ...item,
            properties: item.properties,
            metadata: item.metadata,
        };
    }
    return {
        async search(payload, options) {
            const response = await api.contentSearch(payload, options);
            return {
                object: 'list',
                data: response.data.data.map(parseContentObject),
            };
        },
        async list(payload, options) {
            const response = await api.contentList(payload, options);
            return {
                object: 'list',
                data: response.data.data.map(parseContentObject),
            };
        },
        async retrieve(contentId, options) {
            const response = await api.contentRetrieve({
                contentId,
            }, options);
            return parseContentObject(response.data);
        },
        async create(payload, options) {
            const { workspaceId, ...rest } = options ?? {};
            const response = await api.contentCreate({
                contentCreatePayload: payload,
                xWorkspaceId: workspaceId,
            }, options);
            return parseContentObject(response.data);
        },
        async update(contentId, payload, options) {
            const response = await api.contentUpdate({
                contentId,
                contentUpdatePayload: payload,
            }, options);
            return parseContentObject(response.data);
        },
        async archive(contentId, options) {
            const response = await api.contentArchive({ contentId }, options);
            return parseContentObject(response.data);
        },
    };
}
//# sourceMappingURL=contentProvider.js.map